// extracted by mini-css-extract-plugin
export default {"footerErrorMessage":"styles_footerErrorMessage__LnYB-"};